import React from "react";
import "./Challenges.css";

const Challenges = () => {
  return (
    <div className="color-grade">
      <div className="container challenge-container">
        <div className="row">
          <div className="col-1 col-md-2"></div>
          <div className="col-10 col-md-8">
            <h5 className="challenge-heading">
              You will require IDE-Cloud if you face any of these challenges in
              your BizTalk Server Environment
            </h5>
          </div>
        </div>
        <div className="row mt-5">
          <div className="col-1 d-none d-md-block"></div>
          <div className="col-1">
            <i className="fas fa-tasks fa-3x fa-challenges"></i>
          </div>
          <div className="col-11 col-sm-5 col-md-4">
            <p className="challenges-text">
              My BizTalk Server goes down due to several reasons and I never get
              to know about it immediately unless I receive a phone call from my
              colleague or my manager.
            </p>
          </div>
          <div className="col-1">
            <i className="fab fa-searchengin fa-3x fa-challenge-marginl fa-challenges"></i>
          </div>
          <div className="col-11 col-sm-5 col-md-4">
            <p className="challenges-text">
              We have very little visibility into what is happening within our
              BizTalk Server Environments. We also find it difficult to know how
              the messages flow within the BizTalk server.
            </p>
          </div>
        </div>
        <div className="row mt-4">
          <div className="col-1 d-none d-md-block"></div>
          <div className="col-1">
            <i className="fas fa-project-diagram fa-3x fa-challenges"></i>
          </div>
          <div className="col-11 col-sm-5 col-md-4">
            <p className="challenges-text">
              We rely too much on our BizTalk Administrators to manually carry
              out trivial tasks such as enabling ports, starting orchestrations,
              enlisting send ports, and so on.
            </p>
          </div>
          <div className="col-1">
            <i className="fas fa-align-right fa-3x fa-challenge-marginl fa-challenges"></i>
          </div>
          <div className="col-11 col-sm-5 col-md-4">
            <p className="challenges-text">
              There is absolutely no clue as to who made the changes as nothing
              is audited in the environment. Our support people got
              administrative rights on BizTalk and SQL Servers.
            </p>
          </div>
        </div>
        <div className="row mt-5">
          <div className="col-3 col-md-4 col-xl-5"></div>
          <div className="col-6 col-md-4 col-xl-2">
            <button className="btn btn-outline-light btn-product">
              Take a Product Tour 
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Challenges;
